import EnvelopeIcon from "./EnvelopeIcon"

export default  EnvelopeIcon;
